import { useCallback } from "react";
import { toast } from "react-toastify";
import {
  useApprovalsApprove,
  useApprovalsRefuse,
  useSendToApproval,
  useApprovalsApprovePerManager,
  useReportPay,
  useMarkAdvanceAsPaid,
} from "../service/reportEntry";

interface ReportActionPayload {
  id: number;
  refuseReason?: string;
  approveReason?: string;
}

export const useReportActions = () => {
  const { mutate: approve } = useApprovalsApprove();
  const { mutate: refuse } = useApprovalsRefuse();
  const { mutate: sendToApproval } = useSendToApproval();
  const { mutate: approvePerManager } = useApprovalsApprovePerManager();
  const { mutate: reportPay } = useReportPay();
  const { mutate: markAdvanceAsPaid } = useMarkAdvanceAsPaid();

  const onRequestAction = useCallback(
    (action: string, payload: ReportActionPayload, onSuccess?: () => void) => {
      switch (action) {
        case "approve":
          approve(payload, {
            onSuccess: () => {
              onSuccess?.();
            },
          });
          break;
        case "approvePerManager":
          if (!payload.approveReason || payload.approveReason.trim() === "") {
            toast.error("Motivo da aprovação é obrigatório");
            return;
          }
          approvePerManager(payload, {
            onSuccess: () => {
              onSuccess?.();
            },
          });
          break;
        case "refuse":
          if (!payload.refuseReason) {
            toast.error("Motivo de rejeição é obrigatório");
            return;
          }
          refuse(
            { id: payload.id, refuseReason: payload.refuseReason },
            {
              onSuccess: () => {
                onSuccess?.();
              },
            },
          );
          break;
        case "sendToApproval":
          sendToApproval(payload.id, {
            onSuccess: () => {
              onSuccess?.();
            },
          });
          break;
        case "markAsPaid":
          // Usar reportPay para reembolsos normais e markAdvanceAsPaid para adiantamentos
          // A lógica será determinada no componente que chama esta função
          reportPay(payload.id, {
            onSuccess: () => {
              onSuccess?.();
            },
          });
          break;
      }
    },
    [approve, refuse, sendToApproval, approvePerManager, reportPay, markAdvanceAsPaid],
  );

  return {
    onRequestAction,
  };
};
